(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pb-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pb-announcement-bar')) {
    customElements.define('pb-announcement-bar', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.messages = [...this.querySelectorAll('[data-message]')];
        this.index = 0;
        this.manualPause = false;
        this.hovered = false;
        this.focused = false;
        this.inView = true;
        this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
        this.pauseButton = this.querySelector('[data-pause]');
        this.pauseButton?.addEventListener('click', () => {
          this.manualPause = !this.manualPause;
          this.pauseButton.setAttribute('aria-pressed', String(this.manualPause));
          this.pauseButton.textContent = this.manualPause ? this.pauseButton.dataset.playLabel : this.pauseButton.dataset.pauseLabel;
          this.schedule();
        }, options);
        this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, options);
        this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, options);
        this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
        this.addEventListener('focusout', event => { this.focused = this.contains(event.relatedTarget); this.schedule(); }, options);
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        this.motionListener = () => this.schedule();
        this.reducedMotion.addEventListener('change', this.motionListener);
        document.addEventListener('shopify:block:select', event => {
          const index = this.messages.findIndex(message => message.dataset.blockId === event.detail.blockId);
          if (index >= 0) { this.editorSelected = true; this.show(index); this.schedule(); }
        }, options);
        document.addEventListener('shopify:block:deselect', () => { this.editorSelected = false; this.schedule(); }, options);
        this.observer = new IntersectionObserver(entries => { this.inView = entries[0].isIntersecting; this.schedule(); });
        this.observer.observe(this);
        this.schedule();
      }
      show(index) {
        this.index = index;
        this.messages.forEach((message, i) => {
          const active = i === index;
          message.classList.toggle('is-active', active);
          message.toggleAttribute('inert', !active);
          if (active) message.removeAttribute('aria-hidden');
          else message.setAttribute('aria-hidden', 'true');
        });
      }
      schedule() {
        clearTimeout(this.timer);
        if (this.dataset.autoplay !== 'true' || this.messages.length < 2 || this.manualPause || this.hovered || this.focused || this.editorSelected || document.hidden || !this.inView || this.reducedMotion.matches) return;
        this.timer = setTimeout(() => { this.show((this.index + 1) % this.messages.length); this.schedule(); }, Number(this.dataset.interval) || 5500);
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.controller?.abort();
        this.observer?.disconnect();
        this.reducedMotion?.removeEventListener('change', this.motionListener);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pb-luxury-benefits"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pb-benefits-strip')) {
    customElements.define('pb-benefits-strip', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.updateMotion = () => this.toggleAttribute('data-enhanced', this.dataset.autoplay === 'true' && this.dataset.editor !== 'true' && !this.motion.matches);
        this.motion.addEventListener('change', this.updateMotion);
        this.updateMotion();
        this.observer = new IntersectionObserver(entries => this.setAttribute('data-in-view', String(entries[0].isIntersecting)));
        this.observer.observe(this);
        document.addEventListener('visibilitychange', () => this.toggleAttribute('data-document-hidden', document.hidden), { signal: this.controller.signal });
        this.querySelector('[data-toggle]').addEventListener('click', event => {
          const paused = this.toggleAttribute('data-paused');
          event.currentTarget.setAttribute('aria-pressed', String(paused));
          event.currentTarget.setAttribute('aria-label', paused ? event.currentTarget.dataset.playLabel : event.currentTarget.dataset.pauseLabel);
        }, { signal: this.controller.signal });
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.controller?.abort();
        this.motion?.removeEventListener('change', this.updateMotion);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
